export default __webpack_public_path__ + "static/media/IconDesc_Valve.256.15556333.png";